import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { daysUntilRoundedUp, parseDate } from '../common/timeUtil.js';


export const CallToAction = createReactClass({
    propTypes: {
        hasTff: PropTypes.bool.isRequired,
        tffExpirationDate: PropTypes.string, // null if not assigned TFF or if in instant fundraising
        tffName: PropTypes.string,
        tffAmount: PropTypes.string,
        className: PropTypes.string,
    },

    getTimeLeftSection: function () {
        const falloffDate = parseDate(this.props.tffExpirationDate);
        const numberDaysLeft = daysUntilRoundedUp(falloffDate);

        const daysLeftText = numberDaysLeft === 1 ? 'day' : numberDaysLeft + ' days';
        return (
            <span>{daysLeftText}</span>
        );
    },

    render: function () {
        let content;

        if (this.props.hasTff) {
            content = (
                <div className={this.props.className}>
                    <p>
                        Tell donors to double donations up to {this.props.tffAmount} by adding the
                        promo&nbsp;code <span className="highlight-promo">{this.props.tffName}</span> at
                        checkout for the next <strong>{this.getTimeLeftSection()}</strong>.
                    </p>
                </div>
            );
        } else {
            content = null;
        }

        return content;
    },
});
